export default __webpack_public_path__ + "static/media/affiliate-jushinkan.a326e85c.png";